<template lang="pug">
	.streamings-selection
		.flex-row.space
			ListView.full-width(ref="listView", :getTotal="(data) => data.total", :getItems="(data) => data.items", :getData="loadData", :columns="columns")
				template(v-slot:card="{ data }")
					.flex-col.streaming-card(:class="{ selected: productStreamings.indexOf(data.id) > -1 }")
						.flex-row.justify
							.img
								.img-holder(:style="{ backgroundImage: `url(${data.logo})` }")
							.flex-row.align-center
								.font-big.upper {{data.adPlacement}}
						b {{data.name}}
						.flex-row.justify.dates.space-large.nowrap
							.flex-col(v-if="getRatingMethod(data.ratingMethod)")
								.upper.font-small.grey {{$tCaption('Rating method')}}
								span {{getRatingMethod(data.ratingMethod)}}
							.flex-col(v-if="getAdRunType(data.adRunType)")
								.upper.font-small.grey {{$tCaption('Run type')}}
								span {{getAdRunType(data.adRunType)}}
						.dto(v-if="data.dto > 0") -{{data.dto}}%
						.bottom-part.flex-col
							.flex-row.justify.margin-top.upper.bold
								span {{data.duration}} {{$tCaption('seconds')}}
								span {{$tCaption('CPM')}} {{formatNumber(data.cpm, '0.##')}}$
							.font-big {{formatNumber(data.impressions, 'fixedPoint')}} {{$tCaption('impressions')}}
							.price.flex-row.margin-top.align-center.space-large(:class="[data.price != data.agreedPrice ? 'justify' : 'center']")
								.agreed-price ${{formatNumber(data.agreedPrice, 'fixedPoint', 2)}}
								.old-price(v-if="data.price != data.agreedPrice") ${{formatNumber(data.price, 'fixedPoint', 2)}}
							.flex-row.center.align-center.margin-top
								DxButton(v-if="productStreamings.indexOf(data.id) == -1", text="Add", type="default", @click="toggleStreaming(data.id)")
								DxButton(v-else, :text="$tCaption('Remove')", type="normal", @click="toggleStreaming(data.id)")
				.filters-panel.flex-col.wrap.space(v-if="streamings", slot="left")
					.flex-row.space.align-center
						DxSelectBox(:data-source="networks", :searchEnabled="true", :value.sync="filters.network", display-expr="name", value-expr="id", :placeholder="$tCaption('Network')")
						.clickable(v-if="filters.network", @click="filters.network = null")
							i.fas.fa-times-circle
					.flex-row.space.align-center
						DxSelectBox(:data-source="adPlacements", :value.sync="filters.adPlacement", display-expr="name", value-expr="id", :placeholder="$tCaption('Placement')")
						.clickable(v-if="filters.adPlacement", @click="filters.adPlacement = null")
							i.fas.fa-times-circle
					.flex-row.space.align-center
						DxSelectBox(:data-source="ratingMethods", :value.sync="filters.ratingMethod", display-expr="name", value-expr="id", :placeholder="$tCaption('Rating method')")
						.clickable(v-if="filters.ratingMethod", @click="filters.ratingMethod = null")
							i.fas.fa-times-circle
					RangeFilter(ref="duration", :title="$tCaption('Duration')", width="200px", v-model="filters.duration", :min="streamings.summaries.minLength", :max="streamings.summaries.maxLength")
					RangeFilter(ref="price", :title="$tCaption('Price')", width="200px", v-model="filters.price")
					DxButton(text="Apply filters", type="default", @click="$refs.listView.loadData({ clear: true })")
				template(v-slot:name-cell-template="{ data }")
					.flex-row.table-info.space.align-center
						.img-holder(:style="{ backgroundImage: `url(${data.logo})` }")
						.flex-col.space
							b.title.wrap {{data.name}}
				template(v-slot:add-cell-template="{ data }")
					DxButton(v-if="productStreamings.indexOf(data.id)", :text="$tCaption('Add')", type="default", @click="toggleStreaming(data.id)")
					DxButton(v-else, :text="$tCaption('Remove')", type="danger", @click="toggleStreaming(data.id)")
				template(v-slot:dto-cell-template="{ data }")
					.table-info
						.dto-red(v-if="data.dto > 0") -{{data.dto}}%
</template>

<script>
	import Data from 'app-core/Data';
	import ListView from 'app-core/ListView.vue';
	import RangeFilter from 'app-core/RangeFilter.vue';
	import DxButton from 'devextreme-vue/button';
	import DxSelectBox from 'devextreme-vue/select-box';
	import DxDateBox from 'devextreme-vue/date-box';
	import { DxNumberBox } from 'devextreme-vue/number-box';

	export default {
		translationCategory: 'proposal.StreamingsSelection',
		name: 'streamings-selection',
		components: {ListView, RangeFilter, DxButton, DxSelectBox, DxDateBox, DxNumberBox},
		mixins: [Data.mixin],
		props: ['data', 'productId', 'productInfo'],
		data() {
			return {
				columns: [
					{
						dataField: 'name',
						caption: () => this.$tCaption('Streaming'),
						cellTemplate: 'name-cell-template'
					},
					{ dataField: 'adPlacement', caption: () => this.$tCaption('Placement') },
					{ dataField: 'startTime', caption: () => this.$tCaption('Start'),  dataType: 'date', format: 'shortDateShortTime' },
					{ dataField: 'price', caption: () => this.$tCaption('Price'),  dataType: 'number', format: { type: 'fixedPoint', precision: 2 } },
					{ dataField: 'agreedPrice', caption: () => this.$tCaption('Agreed price'),  dataType: 'number', format: { type: 'fixedPoint', precision: 2 } },
					{ dataField: 'impressions', caption: () => this.$tCaption('Impressions'),  dataType: 'number', format: 'fixedPoint' },
					{ dataField: 'cpm', caption: () => this.$tCaption('CPM'),  dataType: 'number', format: '#0.##' },
					{ dataField: 'dto', caption: () => this.$tCaption('DTO'),  cellTemplate: 'dto-cell-template', width: 80 },
					{ dataField: 'name', cellTemplate: 'add-cell-template', caption: '', width: 80 },
					{ caption: '', width: 0 }
				],
				filters: {
					network: null,
					adPlacement: null,
					ratingMethod: null,
					duration: null,
					price: null
				},
				adPlacements: [],
				networks: [],
				ratingMethods: [],
				streamings: null
			};
		},
		computed: {
			productStreamings() {
				return this.productInfo && this.productInfo.streamings || [];
			}
		},
		watch: {
			productId() {
				if (this.$refs.listView)
					this.$refs.listView.reload({ clear: true });
			}
		},
		mounted() {
			Data.getAdPlacements().then(r => this.adPlacements = r);
			Data.getNetworks().then(r => this.networks = r);
			Data.getEducationLevels().then(r => this.educationLevelsSource = r);
			Data.getRatingMethods().then(r => this.ratingMethods = r);
		},
		methods: {
			getRatingMethod(id) {
				const item = this.ratingMethods.filter(f => f.id === id)[0];
				return item && item.name;
			},
			getAdRunType(id) {
				const item = this.adPlacements.filter(f => f.id === id)[0];
				return item && item.name;
			},
			loadData(pageIndex, size) {
				var params = {
					NetworkId: this.filters.network,
					MinLength: (this.filters.duration || [])[0] || null,
					MaxLength: (this.filters.duration || [])[1] || null,
					AgreedPriceMin: (this.filters.price || [])[0] || null,
					AgreedPriceMax: (this.filters.price || [])[1] || null,
					DapCategoryList: [this.productId]
				};

				if (this.filters.adPlacement)
					params.AdRunType = this.filters.adPlacement;

				if (this.filters.ratingMethod)
					params.RatingMethod = this.filters.ratingMethod;

				return Data.getStreamings(pageIndex, size, params).then(r => {
					if (__DEBUG__)
						console.info('Streamings loaded', { r, params });
					if (!this.streamings)
						this.streamings = r;
					return r;
				});
			},
			toggleStreaming(id) {
				if (this.productStreamings.indexOf(id) > -1)
					this.productStreamings.splice(this.productStreamings.indexOf(id), 1);
				else
					this.productStreamings.push(id);
			}
		}
	};
</script>
<style lang='scss'>
	.streamings-selection {
		@import "main/themes/generated/variables.base.scss";

		.table-info {
			.img-holder {
				width: 80px;
				height: 80px;
				min-width: 80px;

				background-size: contain;
				background-position: center;
				border-radius: 4px;
				background-repeat: no-repeat;
			}

			.dto-red {
				padding: 4px;
				background: #e45656;
				text-align: center;
				color: #ffff;
				border-radius: 10px;
			}
		}

		.filters-panel {
			padding: 20px;
			flex-basis: 300px;
			background: #fff;

			> *:not(:first-child) {
				margin-top: 20px;
			}
		}

		.streaming-card {
			-webkit-box-shadow: 2px 2px 13px 2px rgba(0, 0, 0, 0.1);
			-moz-box-shadow: 2px 2px 13px 2px rgba(0, 0, 0, 0.1);
			box-shadow: 2px 2px 13px 2px rgba(0, 0, 0, 0.1);
			min-width: 240px;
			background: #ffffff;
			border-radius: 4px;
			color: #000;
			position: relative;
			transition: 0.5s;

			.bottom-part {
				transition: 0.5s;
				background: rgba(0, 0, 0, 0);
			}

			.dates {
				transition: 0.5s;
				background: rgba(0,0,0,0.04);
				padding: 10px;
				margin-top: 10px;
				border-bottom: 2px solid $base-accent;
			}

			&:hover {
				transform: scale(1.05) translateY(-8px);

				.dates {
					background: $base-accent;
					color: $base-bg;

					.grey {
						color: $base-bg-transparent;
					}
				}
			}

			&.selected {
				.dates {
					background: #9becda;
					color: #43b198;
					border-bottom: 2px solid #9becda;

					.grey {
						color: #43b19880;
					}
				}
			}

			> * {
				padding: 0px 20px;

				&:first-child {
					padding-top: 10px;
				}

				&:last-child {
					padding-bottom: 10px;
				}
			}

			.margin-top {
				margin-top: 20px;
			}

			.bold {
				font-weight: 600;
			}

			.img-holder {
				height: 60px;
				width: 80px;

				background-size: cover;
				background-position: center;
				border-radius: 4px;
			}

			.price {
				font-size: 24px;
				font-weight: 100;
				color: #00bf06;

				> .old-price {
					color: #ff0000ba;
					text-decoration: line-through;
				}
			}

			.dto {
				position: absolute;
				top: -20px;
				right: -20px;
				border-radius: 100px;
				background: #ff4343;
				padding: 8px;
				width: 60px;
				height: 60px;
				line-height: 2.3;
				text-align: center;
				font-size: 20px;
				font-weight: 100;
				color: #fff;
			}
		}
	}
</style>
